<template>
  <v-card elevation="0">
    <v-card-title class="pa-0">
      <v-card-actions>
        <v-btn
          icon
          small
          @click="showPlanCard = !showPlanCard"
        >
          <v-icon>{{ showPlanCard ? 'fas fa-minus' : 'fas fa-plus' }}</v-icon>
        </v-btn>
      </v-card-actions>
      Planos
      <v-btn icon small @click="addNewPlan">
        <v-icon small dark title="Criar">fas fa-plus</v-icon>
      </v-btn>
    </v-card-title>
 
    <v-expand-transition>
      <div v-show="showPlanCard">
        <v-card-text class="pt-0">

          <v-simple-table v-if="plans">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left col-2"></th>
                <th class="text-center col-1">
                  Total
                </th>
                <th class="text-center col-2"
                    v-for="(item,index) in plans">

                  <v-btn icon small @click="removePlan(index)">
                    <v-icon small dark title="Remover">fas fa-times</v-icon>
                  </v-btn>

                  <v-autocomplete
                    v-model="item.product"
                    :items="planNames"
                    return-object
                    item-value="id"
                    item-text="fullDescription"
                    :loading="planNames.length==0" dense outlined
                    @change="linkPlanWithCarrierCurrentPlan(index)"
                    style="width:250px"
                  ></v-autocomplete>
                  
                </th>
                <th class="text-left col-8"></th>
              </tr> 
              </thead>
              <tbody>
              <tr>
                <td>Até 18 anos</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.untilEighteenPeople}}</td>
                <td v-for="(item,index) in plans">
                  <v-text-field  v-model="item.untilEighteenPeople" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('untilEighteenPeople',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>19 até 23 anos</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.nineteenToTwentyThreePeoples}}</td>
                <td v-for="(item,index) in plans">
                  <v-text-field  v-model="item.nineteenToTwentyThreePeoples" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('nineteenToTwentyThreePeoples',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>24 até 28 anos</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.twentyFourToTwentyEightPeoples}}</td>
                <td v-for="(item,index) in plans">
                  <v-text-field  v-model="item.twentyFourToTwentyEightPeoples" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('twentyFourToTwentyEightPeoples',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>29 até 33 anos</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.twentyNineToThirtyThreePeoples}}</td>
                <td v-for="(item,index) in plans">
                  <v-text-field  v-model="item.twentyNineToThirtyThreePeoples" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('twentyNineToThirtyThreePeoples',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>34 até 38 anos</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.thirtyFourToThirtyEightPeoples}}</td>
                <td
                  v-for="(item,index) in plans">
                  <v-text-field  v-model="item.thirtyFourToThirtyEightPeoples" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('thirtyFourToThirtyEightPeoples',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>39 até 43 anos</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.thirtyNineToFortyThreePeoples}}</td>
                <td v-for="(item,index) in plans">
                  <v-text-field  v-model="item.thirtyNineToFortyThreePeoples" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('thirtyNineToFortyThreePeoples',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>44 até 48 anos</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.fortyFourToFortyEightPeoples}}</td>
                <td v-for="(item,index) in plans">
                  <v-text-field  v-model="item.fortyFourToFortyEightPeoples" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('fortyFourToFortyEightPeoples',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>49 até 53 anos</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.fortyNineToFiftyThreePeoples}}</td>
                <td v-for="(item,index) in plans">
                  <v-text-field  v-model="item.fortyNineToFiftyThreePeoples" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('fortyNineToFiftyThreePeoples',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>54 até 58 anos</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.fiftyFourToFiftyEightPeoples}}</td>
                <td v-for="(item,index) in plans">
                  <v-text-field  v-model="item.fiftyFourToFiftyEightPeoples" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('fiftyFourToFiftyEightPeoples',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td><pre style="font-family: Roboto, sans-serif">A partir de 59 anos</pre></td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.fromFiftyNinePeoples}}</td>
                <td v-for="(item,index) in plans">
                  <v-text-field  v-model="item.fromFiftyNinePeoples" class="centered-input" v-mask="$util.formmasks.number" @keyup="sumTotalPeoplePlan('fromFiftyNinePeoples',index)"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td class="text-center">{{totalHealthCarePlanAgeGroup.overall}}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          
          <Title title="Desenho do Benefício"></Title>
          <v-simple-table v-if="plans">
            <template v-slot:default>
              <tbody>
              <tr>
                <td class="col-3 pl-0">Nome do Plano</td>
                <td class="col-2"
                    v-for="item in plans">
                  <strong>{{item.product.productCode}} - {{item.product.description}}</strong>
                </td>
              </tr>
              <tr>
                <td class="col-3 pl-0">Premio / Custo Unitário</td>
                <td class="col-2"
                    v-for="item in plans">
                  <v-text-field  v-model="item.unitCost" v-mask="$util.formmasks.money" class="text-center">
                    <v-icon
                      slot="prepend"
                    >
                      R$
                    </v-icon>
                  </v-text-field>
                </td>
              </tr>
              <tr>
                <td class="col-3 pl-0">Elegibilidade*</td>
                <td class="col-2"
                    v-for="item in plans">
                  <v-textarea v-model="item.elegibility" rows="3"></v-textarea>
                </td>
              </tr>
              <tr>
                <td class="col-3 pl-0">Contribuição Colaborador*</td>
                <td class="col-2"
                    v-for="item in plans">
                  <v-textarea v-model="item.contribution" rows="3"></v-textarea>
                </td>
              </tr>
              <tr>
                <td class="col-3 pl-0">Reembolso de Consulta</td>
                <td class="col-2"
                    v-for="(item,index) in plans">
                  <v-text-field  v-model="item.consultationRefund" v-mask="$util.formmasks.money" class="text-center" @keyup="linkRefundWithCarrierCurrentPlan(index)">
                    <v-icon
                      slot="prepend"
                    >
                      R$
                    </v-icon>
                  </v-text-field>
                </td>
              </tr>
              <tr>
                <td class="col-3 pl-0">Coparticipação*</td>
                <td class="col-2"
                    v-for="item in plans">
                  <v-select :items="coparticipationTypes" item-value="id" item-text="description" return-object v-model="item.copay.type"></v-select>
                </td>
              </tr>
              <tr>
                <td class="col-3 pl-0">Desenho da Coparticipação - Consultas</td>
                <td class="col-2"
                    v-for="item in plans">
                  <v-textarea rows="3" v-model="item.copay.consultationDesign" class="text-center" v-if="item.copay.type!=null && item.copay.type.description!='Sem Coparticipação'"></v-textarea>
                </td>
              </tr>
              <tr>
                <td class="col-3 pl-0">Desenho da Coparticipação - Cons. P.S.</td>
                <td class="col-2"
                    v-for="item in plans">
                  <v-textarea rows="3" v-model="item.copay.consultationPSDesign" class="text-center" v-if="item.copay.type!=null && item.copay.type.description!='Sem Coparticipação'"></v-textarea>
                </td>
              </tr>
              <tr>
                <td class="col-3 pl-0">Desenho da Coparticipação - Exames</td>
                <td class="col-2"
                    v-for="item in plans">
                  <v-textarea rows="3" v-model="item.copay.examsDesign" class="text-center" v-if="item.copay.type!=null && item.copay.type.description!='Sem Coparticipação'"></v-textarea>
                </td>
              </tr>
              <tr>
                <td class="col-3 pl-0">Desenho da Coparticipação - Outros</td>
                <td class="col-2"
                    v-for="item in plans">
                  <v-textarea v-model="item.copay.otherDesigns" rows="3" v-if="item.copay.type!=null && item.copay.type.description!='Sem Coparticipação'"></v-textarea>
                </td>
                <td class="text-left col-8"></td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <h4>Coberturas Diferenciadas
          <v-btn icon small>
            <v-icon small dark title="Criar" @click="showCoverageTypeDialog=true">fas fa-plus</v-icon>
          </v-btn></h4>

          <v-dialog
            v-model="showCoverageTypeDialog"
            width="500"
          >
            <v-card
              elevation="2"
              outlined
            >
              <v-card-title class="text-h5 muted lighten-2">
                Coberturas Diferenciadas
              </v-card-title>

              <v-card-text>
                <v-autocomplete
                  label="Cobertura"
                  v-model="othersCoverageSelected"
                  :items="othersCoverageTypeItens"
                  item-value="id"
                  item-text="name"
                  return-object
                  multiple
                ></v-autocomplete>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  small
                  @click="addOthersCoverageInPlans"
                >
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-simple-table v-if="showOthersCoverageSelected">
            <template v-slot:default>
              <tbody>
              <tr
                v-for="(cob, index) in othersCoverageSelected" :key="'coverage_'+index">
                <td class="col-3 pl-0">{{ cob.name }}</td>
                <td class="col-2"
                    v-for="(p, pIndex) in plans" :key="'plan_'+pIndex">

                  <!-- Cobertura com valor texto -->
                  <v-text-field v-model="p.othersCoverage[index].value" class="text-center"></v-text-field>

                </td>
                <td class="text-left col-8"></td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import ProductService from "@/services/odoo/ProductService";
import Title from "@/components/structure/title"
import CoverageService from "@/services/odoo/CoverageService";

export default {
  components: {Title},
  props:{
    account:{
      type: Object
    },
    benefit:{
      type: Object
    },
    totalHealthCarePlanAgeGroup:{
      type: Object
    },
    plans: {
      type: []
    },
    carrierCurrentPlan:{
      type: Object
    },
    carrierProposedPlan:{
      type: []
    }
  },
  data(){
    return {
      showPlanCard: true,
      showCoverageTypeDialog: false,
      coparticipationTypes: [{id: 1, description:"Mista"}, {id: 2, description:"Revertido para a Empresa"}, {id: 3, description:"Revertido para a Operadora"}, {id: 4, description:"Sem Coparticipação"}],
      showOthersCoverageSelected: false,
      othersCoverageSelected: [],
      othersCoverageTypeItens: [],
      planNames: [],
      product: {}
    }
  },
  async created() {
    this._productService = new ProductService();
    this._coverageService = new CoverageService();
  },
  async mounted(){
    if (this.othersCoverageTypeItens.length==0 && this.benefit && this.benefit.xipp_contract_record_type_code) {
      this.findCoverages(this.benefit.xipp_contract_record_type_code);
    }

    if(this.plans.length>0 && this.plans[0].othersCoverage && this.plans[0].othersCoverage.length>0){
      this.othersCoverageSelected.splice(0);
      this.othersCoverageSelected = this.plans[0].othersCoverage;
      this.showOthersCoverageSelected = true;
    }

    if(this.plans.length>0 && this.planNames.length==0){
      this.findPlanNames(this.account.id, this.benefit.id);
    }
    if(this.plans.length>0) {
      this.plans.forEach((p, index) => {
        this.sumTotalPeoplePlan('untilEighteenPeople', index);
        this.sumTotalPeoplePlan('nineteenToTwentyThreePeoples', index);
        this.sumTotalPeoplePlan('twentyFourToTwentyEightPeoples', index);
        this.sumTotalPeoplePlan('twentyNineToThirtyThreePeoples', index);
        this.sumTotalPeoplePlan('thirtyFourToThirtyEightPeoples', index);
        this.sumTotalPeoplePlan('thirtyNineToFortyThreePeoples', index);
        this.sumTotalPeoplePlan('fortyFourToFortyEightPeoples', index);
        this.sumTotalPeoplePlan('fortyNineToFiftyThreePeoples', index);
        this.sumTotalPeoplePlan('fiftyFourToFiftyEightPeoples', index);
        this.sumTotalPeoplePlan('fromFiftyNinePeoples', index);
      });
    }
  },
  methods:{
    linkPlanWithCarrierCurrentPlan(index){
      this.carrierCurrentPlan.plans[index].product=this.plans[index].product;
            
      let consultationRefund = this.plans[index].product.refunds.filter(r => r.event == 'Consulta Eletiva');
      let psychotherapyRefund = this.plans[index].product.refunds.filter(r => r.event == 'Sessão de Psicoterapia');
      let physiotherapyRefund = this.plans[index].product.refunds.filter(r => r.event == 'Fisioterapia');
      let skullTomographyRefund = this.plans[index].product.refunds.filter(r => r.event == 'Tomografia de Crânio');
      let caesareanBirthRefund = this.plans[index].product.refunds.filter(r => r.event == 'Parto Cesárea');
      let revascularizationMyocardiumRefund = this.plans[index].product.refunds.filter(r => r.event == 'Revascularização do Miocárdio');
      this.carrierCurrentPlan.plans[index].consultationRefund=consultationRefund && consultationRefund.length>0 ? consultationRefund[0].value.toFixed(2).replace('.',',') : null;
      this.carrierCurrentPlan.plans[index].psychotherapyRefund=psychotherapyRefund && psychotherapyRefund.length>0 ? psychotherapyRefund[0].value.toFixed(2).replace('.',',') : null;
      this.carrierCurrentPlan.plans[index].physiotherapyRefund=physiotherapyRefund && physiotherapyRefund.length>0 ? physiotherapyRefund[0].value.toFixed(2).replace('.',',') : null;
      this.carrierCurrentPlan.plans[index].skullTomographyRefund=skullTomographyRefund && skullTomographyRefund.length>0 ? skullTomographyRefund[0].value.toFixed(2).replace('.',',') : null;
      this.carrierCurrentPlan.plans[index].caesareanBirthRefund=caesareanBirthRefund && caesareanBirthRefund.length>0 ? caesareanBirthRefund[0].value.toFixed(2).replace('.',',') : null;
      this.carrierCurrentPlan.plans[index].revascularizationMyocardiumRefund=revascularizationMyocardiumRefund && revascularizationMyocardiumRefund.length>0 ? revascularizationMyocardiumRefund[0].value.toFixed(2).replace('.',',') : null;
    },
    linkTotalLivesPlanWithCarrierCurrentPlan(index){
      this.carrierCurrentPlan.plans[index].lives=0;
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].untilEighteenPeople);
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].nineteenToTwentyThreePeoples);
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].twentyFourToTwentyEightPeoples);
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].twentyNineToThirtyThreePeoples);
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].thirtyFourToThirtyEightPeoples);
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].thirtyNineToFortyThreePeoples);
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].fortyFourToFortyEightPeoples);
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].fortyNineToFiftyThreePeoples);
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].fiftyFourToFiftyEightPeoples);
      this.carrierCurrentPlan.plans[index].lives += parseInt(this.plans[index].fromFiftyNinePeoples);
    },
    linkRefundWithCarrierCurrentPlan(index){
      this.carrierCurrentPlan.plans[index].consultationRefund = this.plans[index].consultationRefund;
    },
    addCarrierCurrentPlan(){
      this.carrierCurrentPlan.plans.push({
        product: {},
        consultationRefund: null,
        psychotherapyRefund: null,
        physiotherapyRefund: null,
        skullTomographyRefund: null,
        caesareanBirthRefund: null,
        revascularizationMyocardiumRefund: null,
        lives: null,
        openAgeGroupCost: false,
        openInactiveAgeGroupCost: false,
        openHouseHoldAgeGroupCost: false,
      });
    },
    addCarrierProposedPlan(index){
      if(!this.carrierProposedPlan[index]) {
        this.carrierProposedPlan.push({
          width: 345,
          adm: false,
          carrier: null,
          notes: null,
          isReferencedCarrier: index == 0,
          plans: [],
          plansType: []
        });
      }
      this.carrierProposedPlan[index].plans.push({
        plansType:[],
        linedPlans: [{
          product: {},
          consultationRefund: null,
          psychotherapyRefund: null,
          physiotherapyRefund: null,
          skullTomographyRefund: null,
          caesareanBirthRefund: null,
          revascularizationMyocardiumRefund: null,
          lives: null,
          copay:{averageCost: null},
          secondCopay:{averageCost: null},
          inactiveLives: null,
          inactiveCopay:{averageCost: null},
          inactiveSecondCopay:{averageCost: null},
          houseHoldLives: null,
          houseHoldCopay:{averageCost: null},
          houseHoldSecondCopay:{averageCost: null},
          upgradePlans: [],
          downgradePlans: [],
          ageGroupCost: [],
          inactiveAgeGroupCost: [],
          houseHoldAgeGroupCost: []
        }]
      });
      for (let i = 0; i < 10; i++) {
        this.carrierProposedPlan[index].plans[this.carrierProposedPlan[index].plans.length-1].linedPlans[0].ageGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null
        });
        this.carrierProposedPlan[index].plans[this.carrierProposedPlan[index].plans.length-1].linedPlans[0].inactiveAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null
        });
        this.carrierProposedPlan[index].plans[this.carrierProposedPlan[index].plans.length-1].linedPlans[0].houseHoldAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null
        });
      }
    },
    async addNewPlan(){

      this.plans.push(
        {
          product: {},
          untilEighteenPeople: 0,
          nineteenToTwentyThreePeoples: 0,
          twentyFourToTwentyEightPeoples: 0,
          twentyNineToThirtyThreePeoples: 0,
          thirtyFourToThirtyEightPeoples: 0,
          thirtyNineToFortyThreePeoples: 0,
          fortyFourToFortyEightPeoples: 0,
          fortyNineToFiftyThreePeoples: 0,
          fiftyFourToFiftyEightPeoples: 0,
          fromFiftyNinePeoples: 0,
          unitCost: 0,
          elegibility: null,
          contribution: null,
          consultationRefund: 0,
          psychotherapyRefund: null,
          physiotherapyRefund: null,
          skullTomographyRefund: null,
          caesareanBirthRefund: null,
          revascularizationMyocardiumRefund: null,
          copay: {
            type: null,
            consultationDesign: null,
            consultationPSDesign: null,
            examsDesign: null,
            otherDesigns:null
          },
          othersCoverage: []
        }
      );

      if (this.planNames.length==0) {
        this.findPlanNames(this.account.id,this.benefit.id);
      }

      if (this.othersCoverageTypeItens.length==0) {
        this.findCoverages(this.benefit.xipp_contract_record_type_code);
      }
      
      this.addCarrierCurrentPlan();
      this.addCarrierProposedPlan(0);
      this.addCarrierProposedPlan(1);
      this.addCarrierProposedPlan(2);
      this.addCarrierProposedPlan(3);
     
      this.othersCoverageSelected.forEach(o => {
        this.plans[this.plans.length-1].othersCoverage.push({...o});
      });
    },
    async findPlanNames(accountId, benefitId){
      const {data} = await this._productService.findAllByParams(
        Object.assign(
          this.product,
          {
            carrierId: accountId,
            benefitId: benefitId,
            page: 0,
            sortBy: 'productCode',
            descending: false,
            size: 1000
          }
        )
      )
      this.planNames = data.content;
    },
    async findCoverages(benefitCode){

      let coverage = {recordTypeCode: benefitCode};

      this._coverageService.findAllByParams(
        Object.assign(coverage, {
          page: 0,
          sortBy: 'code',
          descending: false,
          size: 999,
        })
      ).then((response) => {
        console.log(response);
        this.othersCoverageTypeItens = response.data.content;
        console.log(this.othersCoverageTypeItens);
      });
    },
    removePlan(index){
      this.plans.splice(index,1);
      this.carrierCurrentPlan.plans.splice(index,1);
      this.carrierProposedPlan[0].plans.splice(index,1);
      this.carrierProposedPlan[1].plans.splice(index,1);
      this.carrierProposedPlan[2].plans.splice(index,1);
      this.carrierProposedPlan[3].plans.splice(index,1);
    },
    sumTotalOverall(){
      this.totalHealthCarePlanAgeGroup.overall=0;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.untilEighteenPeople;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.nineteenToTwentyThreePeoples;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.twentyFourToTwentyEightPeoples;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.twentyNineToThirtyThreePeoples;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.thirtyFourToThirtyEightPeoples;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.thirtyNineToFortyThreePeoples;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.fortyFourToFortyEightPeoples;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.fortyNineToFiftyThreePeoples;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.fiftyFourToFiftyEightPeoples;
      this.totalHealthCarePlanAgeGroup.overall+=this.totalHealthCarePlanAgeGroup.fromFiftyNinePeoples;
    },
    sumTotalPeoplePlan(ageGroup,index){
      this.totalHealthCarePlanAgeGroup[ageGroup]=0;
      this.plans.filter((plan, index) => plan[ageGroup]).forEach((plan, index) => {
        this.totalHealthCarePlanAgeGroup[ageGroup] += parseInt(plan[ageGroup]);
      });
      this.sumTotalOverall();
      this.linkTotalLivesPlanWithCarrierCurrentPlan(index);
    },
    addOthersCoverageInPlans(){
      
      if(this.othersCoverageSelected.length>0){
        this.plans.forEach(plan => {
          plan.othersCoverage.splice(0);
          this.othersCoverageSelected.forEach(o => {
            plan.othersCoverage.push({...o});
          });
        });
        this.showOthersCoverageSelected=true;  
      } else {
        this.plans.forEach(plan => {
          plan.othersCoverage.splice(0);
        });
        this.showOthersCoverageSelected=false;
      }
      
      this.showCoverageTypeDialog = false;
    }
  },
  name: "include_plan"
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center
}
</style>
